/* global translation */

/**
 * Read more link
 */
jQuery(($) => {
  $('p').html((_, text) => text.replace('<!--more-->', `<span id="more-${Math.floor(Math.random() * 100)}"></span>`));

  const readMore = $('span[id^="more-"]');

  if (readMore.length) {
    $(readMore).each((index, link) => {
      if (!$(link).is(':hidden')) {
        const container = $(link).closest('div');
        if ($(container).hasClass('dont-expand')) {
          return;
        }
        const containerHeight = $(container).height();
        const containerTop = $(container).offset().top;
        const readMoreTop = $(link).offset().top;
        const toReadMore = readMoreTop - containerTop + 35;
        $(container).wrapInner('<div class="i-am-the-expendables"></div>');
        $('.i-am-the-expendables').addClass('have-read-more-toggle').attr('data-og-height', containerHeight).attr('data-min-height', toReadMore);
        $('.i-am-the-expendables').css('height', toReadMore);
        $(`<a href="#" class="added-read-more-link">${translation.read_more}</a>`).insertAfter('.i-am-the-expendables');
      }
    });

    $('.added-read-more-link').on('click', (e) => {
      const button = e.currentTarget;
      const container = $(button).siblings('.have-read-more-toggle');
      const minHeight = $(container).attr('data-min-height');

      if (button.classList.contains('dont-expand')) {
        return;
      }

      e.preventDefault();

      if ($(button).hasClass('clicked')) {
        $(button).text(translation.read_more);
        $(container).removeClass('the-expendables').css('height', minHeight);
      } else {
        $(button).text(translation.close);
        $(container).addClass('the-expendables').removeAttr('style');
      }

      $(button).toggleClass('clicked');
    });
  }
});
